export class ProspectTourSummary {
    constructor (
        public DateTitle: string = null,
        public StartTime: string = null,
        public EndTime: string = null,
        public ProspectEmail: string = null,
        public EventStart: Date = null,
        public EventEnd: Date = null,
        public Address: string = null,
        public AddressShort: string = null,
    ) { }
}
